import React from 'react';
import { Phone, Mail, MapPin, Clock, Printer } from 'lucide-react';
import { locations } from '../mock';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_internal-health/artifacts/32a8oz2n_logo.jpeg"
                alt="Tri-City Internists Logo"
                className="h-16 w-16 object-contain"
              />
              <h3 className="text-white text-lg font-bold">Tri-City Internists</h3>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Dedicated to providing comprehensive adult healthcare with a focus on prevention, 
              chronic disease management, and overall wellness.
            </p>
          </div>

          {/* Saginaw Location */}
          <div>
            <h4 className="text-white font-semibold mb-4">Saginaw Office</h4>
            <div className="space-y-3 text-sm">
              <a 
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locations[0].address + ', ' + locations[0].city + ', ' + locations[0].state + ' ' + locations[0].zip)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start space-x-2 hover:text-white transition-colors"
              >
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" style={{color: 'var(--earth-light)'}} />
                <span>
                  {locations[0].address}<br />
                  {locations[0].city}, {locations[0].state} {locations[0].zip}
                </span>
              </a>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 flex-shrink-0" style={{color: 'var(--earth-light)'}} />
                <a href={`tel:${locations[0].phone.replace(/\D/g, '')}`} className="hover:text-white">
                  {locations[0].phone}
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 flex-shrink-0" style={{color: 'var(--earth-light)'}} />
                <a href={`mailto:${locations[0].email}`} className="hover:text-white break-all">
                  {locations[0].email}
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Printer className="w-4 h-4 flex-shrink-0" style={{color: 'var(--earth-light)'}} />
                <span>Fax: (989) 791-4114</span>
              </div>
            </div>
          </div>

          {/* Frankenmuth Location */}
          <div>
            <h4 className="text-white font-semibold mb-4">Frankenmuth Office</h4>
            <div className="space-y-3 text-sm">
              <a 
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locations[1].address + ', ' + locations[1].city + ', ' + locations[1].state)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start space-x-2 hover:text-white transition-colors"
              >
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" style={{color: 'var(--earth-light)'}} />
                <span>
                  {locations[1].address}<br />
                  {locations[1].city}, {locations[1].state}
                </span>
              </a>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 flex-shrink-0" style={{color: 'var(--earth-light)'}} />
                <a href={`tel:${locations[1].phone.replace(/\D/g, '')}`} className="hover:text-white">
                  {locations[1].phone}
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 flex-shrink-0" style={{color: 'var(--earth-light)'}} />
                <a href={`mailto:${locations[1].email}`} className="hover:text-white break-all">
                  {locations[1].email}
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Printer className="w-4 h-4 flex-shrink-0" style={{color: 'var(--earth-light)'}} />
                <span>Fax: (989) 791-4114</span>
              </div>
            </div>
          </div>

          {/* Office Hours */}
          <div>
            <h4 className="text-white font-semibold mb-4">Office Hours</h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-start space-x-2">
                <Clock className="w-4 h-4 mt-1 flex-shrink-0" style={{color: 'var(--earth-light)'}} />
                <div>
                  <p>Monday - Thursday</p>
                  <p className="text-gray-400">8:00 AM - 4:00 PM</p>
                  <p className="mt-1">Friday</p>
                  <p className="text-gray-400">8:00 AM - 11:00 AM</p>
                </div>
              </div>
              <div className="mt-4">
                <p className="text-white font-medium">After Hours</p>
                <p className="text-gray-400">(989) 583-2362</p>
              </div>
              <div className="mt-4">
                <p className="text-gray-400 text-xs">
                  For medical emergencies, please call 911 or visit your nearest emergency room.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-6 pb-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>&copy; {new Date().getFullYear()} Tri-City Internists. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-white transition-colors">Patient Rights</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
